import { Form, type FormInstance, Select, Spin } from "antd";
import { useStaffList } from "@/modules/staff/hooks/useStaff";
import { ImageUpload } from "@/shared/components/ImageUpload";
import { useFaceEnrollmentStore } from "../store/face-enrollment.store";

interface FaceEnrollmentFormProps {
	form: FormInstance;
	organizationId: string;
}

export function FaceEnrollmentForm({ form, organizationId }: FaceEnrollmentFormProps) {
	const editingItem = useFaceEnrollmentStore((s) => s.editingItem);
	const { data: staffData, isLoading: staffLoading } = useStaffList({
		organizationId,
		page: 1,
		limit: 10,
	});

	const owners = (staffData?.data?.items || []).map((s) => ({
		label: `${s.fullname} (${s.phoneNumber || "No Phone"})`,
		value: s.id,
	}));

	return (
		<Form
			form={form}
			layout="vertical"
			requiredMark={false}
			className="mt-4"
			initialValues={{ organizationId, ownerType: "staff" }}
		>
			<div className="grid grid-cols-2 gap-4">
				<Form.Item name="ownerType" label="Foydalanuvchi turi" rules={[{ required: true }]}>
					<Select placeholder="Tanlang" options={[{ label: "Xodim", value: "staff" }]} />
				</Form.Item>

				<Form.Item
					name="staffId"
					label="Xodimni tanlang"
					rules={[{ required: true, message: "Xodim tanlanishi shart" }]}
				>
					<Select
						showSearch
						loading={staffLoading}
						placeholder="Qidirish..."
						optionFilterProp="label"
						options={owners}
						notFoundContent={staffLoading ? <Spin size="small" /> : null}
					/>
				</Form.Item>

				<Form.Item name="organizationId" noStyle initialValue={organizationId}>
					<input type="hidden" />
				</Form.Item>
			</div>

			<div className="flex justify-center mb-6">
				<Form.Item
					name="faceImageId"
					rules={[{ required: true, message: "Yuz rasmi talab qilinadi" }]}
				>
					<ImageUpload initialUrl={editingItem?.faceImageUrl ?? null} />
				</Form.Item>
			</div>
		</Form>
	);
}
